<template>
    <div v-loading="loading" element-loading-text="加载中..." style="display: inline-block;">
        <el-divider content-position="left">{{title}}</el-divider>
        <el-form ref="form" :model="form" :label-width="formLabelWidth" v-loading="loading"
            element-loading-text="提交中..." class="formbirth d2-mr-20 " size="small">
            <el-row>
                <template v-for="(item, index) in column">
                    <el-col
                        :span="item.type == 'textarea' || item.type == 'upload' || item.type=='text' || item.type=='checkboxArr' || item.col==24 ? 24 : 6"
                        :key="index">
                        <el-form-item :label="item.label" v-if="ifCheck(item)" v-show="!item.hide"
                            :rules="{required:item.ifRequired && eval(item.ifRequired)? true: item.required? item.required: false, message: item.requiredMessage? item.requiredMessage: `请输入${item.label}`, trigger: ['blur', 'change']}">
                            <template v-if="item.type == 'input'">
                                <el-input v-if="item.formatType" placeholder=""
                                    :value="!form[item.field+'Show']?judge(form[item.field],item.formatType):form[item.field]"
                                    @input="form[item.field] = $event"
                                    :readonly="formReadOnly?true:item.readOnly ? item.readOnly : false">
                                    <i slot="suffix" :class="!form[item.field+'Show']?'el-icon-view':'el-icon-error'"
                                        @click="IsDesenHandle(item.field+'Show',form[item.field+'Show'])"></i>
                                </el-input>
                                <el-input v-else v-model="form[item.field]" placeholder=""
                                    :readonly="formReadOnly?true:item.readOnly ? item.readOnly : false"></el-input>
                            </template>
                            <template v-if="item.type == 'text'">
                                <span :style="item.style"><i class="el-icon-warning-outline"></i> {{item.text}}</span>
                            </template>
                            <template v-else-if="item.type == 'checkbox'">
                                <el-checkbox v-for="(v, index) in item.option" :key="index" :label="v.label"
                                    :value="!form[v.field] || form[v.field] == '' ? false : form[v.field] == 'on' ? true : false"
                                    :disabled="formReadOnly?true:item.readOnly ? item.readOnly : false"
                                    style="height: 33px;">
                                </el-checkbox>
                            </template>
                            <template v-else-if="item.type == 'checkboxArr'">
                                <el-checkbox-group v-model="form[item.field]">
                                    <el-checkbox v-for="(items,i) in item.option" :key="i" :label="items.field" disabled>{{ items.label }}</el-checkbox>
                                </el-checkbox-group>
                            </template>
                            <template v-else-if="item.type == 'textarea'">
                                <el-input type="textarea" rows="5" v-model="form[item.field]" placeholder=""
                                    :readonly="formReadOnly?true:item.readOnly ? item.readOnly : false">
                                </el-input>
                            </template>
                            <template v-else-if="item.type == 'select'">
                                <el-select v-model="form[item.field]" placeholder=""
                                    :disabled="formReadOnly?true:item.readOnly ? item.readOnly : false" class="w100">
                                    <el-option v-for="item in item.option" :key="item.value" :label="item.label"
                                        :value="item.value">
                                    </el-option>
                                </el-select>
                            </template>
                            <template v-else-if="item.type == 'upload'">
                                <el-image v-for="(item,index) in form[item.field]"
                                    style="width: 100px; height: 100px;margin-right:10px" :key="index"
                                    :src="item.indexOf('http') != -1 ? item : $apiUrl + item"
                                    :preview-src-list="[item.indexOf('http') != -1 ? item : $apiUrl + item]">
                                </el-image>
                            </template>
                            <template v-else-if="item.type == 'upload2'">
                                <div v-for="(items, i) in form[item.field]" :key="i">
                                    <a :href="items.url" target="_blank">{{items.name}}</a>
                                </div>
                            </template>
                            <template v-else-if="item.type == 'richText'">
                                <el-button type="primary" size="small" @click="open(form[item.field])">查看内容</el-button>
                            </template>
                            <template v-else-if="item.type == 'info'">
                                <el-button type="primary" size="small" @click="openInfo(form[item.field])">查看详情
                                </el-button>
                            </template>
                            <template v-else-if="item.type == 'date'">
                                <el-date-picker v-model="form[item.field]" type="date" placeholder="" class="w100"
                                    :disabled="formReadOnly?true:item.readOnly ? item.readOnly : false">
                                </el-date-picker>
                            </template>
                            <template v-else-if="item.type == 'number'">
                                <el-input-number v-model="form[item.field]" :min="1" :max="item.max"
                                    :disabled="formReadOnly?true:item.readOnly ? item.readOnly : false">
                                </el-input-number>
                            </template>
                        </el-form-item>
                    </el-col>
                </template>
            </el-row>
            <template v-for="(obj,num) in childrenData">
                <el-divider content-position="left" :key="num" v-if="col.length!=0">{{obj.shortTitle}}</el-divider>
                <div :key="num" v-if="col.length!=0" style="margin-bottom:-20px;">
                    <el-row>
                        <template v-for="(item, index) in formcol">
                            <el-col
                                :span="item.type == 'textarea' || item.type == 'upload' || item.type=='text' || item.col==24 ? 24 : 6"
                                :key="index">
                                <el-form-item label-width="180px" :label="item.label" v-if="ifCheck(item)" v-show="!item.hide"
                                    :rules="{required:item.ifRequired && eval(item.ifRequired)? true: item.required? item.required: false, message: item.requiredMessage? item.requiredMessage: `请输入${item.label}`, trigger: ['blur', 'change']}">
                                    <template v-if="item.type == 'input'">
                                        <el-input v-if="item.formatType" placeholder=""
                                            :value="!formDetial[item.field+'Show']?judge(formDetial[item.field],item.formatType):formDetial[item.field]"
                                            @input="formDetial[item.field] = $event"
                                            :readonly="formReadOnly?true:item.readOnly ? item.readOnly : false">
                                            <i slot="suffix"
                                                :class="!formDetial[item.field+'Show']?'el-icon-view':'el-icon-error'"
                                                @click="IsDesenHandle(item.field+'Show',formDetial[item.field+'Show'])"></i>
                                        </el-input>
                                        <el-input v-else v-model="formDetial[item.field]" placeholder=""
                                            :readonly="formReadOnly?true:item.readOnly ? item.readOnly : false">
                                        </el-input>
                                    </template>
                                    <template v-else-if="item.type == 'checkbox'">
                                        <el-checkbox v-for="(v, index) in item.option" :key="index" :label="v.label"
                                            :value="!formDetial[v.field] || formDetial[v.field] == '' ? false : formDetial[v.field] == 'on' ? true : false"
                                            :disabled="formReadOnly?true:item.readOnly ? item.readOnly : false"
                                            style="height: 33px;">
                                        </el-checkbox>
                                    </template>
                                    <template v-else-if="item.type == 'textarea'">
                                        <el-input type="textarea" rows="5" v-model="formDetial[item.field]" placeholder=""
                                            :readonly="formReadOnly?true:item.readOnly ? item.readOnly : false">
                                        </el-input>
                                    </template>
                                    <template v-else-if="item.type == 'select'">
                                        <el-select v-model="formDetial[item.field]" placeholder=""
                                            :disabled="formReadOnly?true:item.readOnly ? item.readOnly : false"
                                            class="w100">
                                            <el-option v-for="item in item.option" :key="item.value" :label="item.label"
                                                :value="item.value">
                                            </el-option>
                                        </el-select>
                                    </template>
                                    <template v-else-if="item.type == 'upload'">
                                        <el-image v-for="(item,index) in formDetial[item.field]"
                                            style="width: 100px; height: 100px;margin-right:10px" :key="index"
                                            :src="item.indexOf('http') != -1 ? item : $apiUrl + item"
                                            :preview-src-list="[item.indexOf('http') != -1 ? item : $apiUrl + item]">
                                        </el-image>
                                    </template>
                                    <template v-else-if="item.type == 'richText'">
                                        <el-button type="primary" size="small" @click="open(formDetial[item.field])">查看内容
                                        </el-button>
                                    </template>
                                    <template v-else-if="item.type == 'info'">
                                        <el-button type="primary" size="small" @click="openInfo(formDetial[item.field])">查看详情
                                        </el-button>
                                    </template>
                                    <template v-else-if="item.type == 'date'">
                                        <el-date-picker v-model="formDetial[item.field]" type="date" placeholder=""
                                            class="w100"
                                            :disabled="formReadOnly?true:item.readOnly ? item.readOnly : false">
                                        </el-date-picker>
                                    </template>
                                    <template v-else-if="item.type == 'number'">
                                        <el-input-number v-model="formDetial[item.field]" :min="1" :max="item.max"
                                            :disabled="formReadOnly?true:item.readOnly ? item.readOnly : false">
                                        </el-input-number>
                                    </template>
                                </el-form-item>
                            </el-col>
                        </template>
                    </el-row>
                </div>
                <template v-if="col.length!=0">
                    <el-table :data="outData" style="width: 98%;margin:20px auto;" row-key="id" border stripe
                        size='small' fit :default-expand-all='false'
                        :tree-props="{children: 'children', hasChildren: 'hasChildren'}" :span-method="arraySpanMethod"
                        :key="num">
                        <el-table-column prop="mark" label="分站" v-if="slot=='jf'">
                            <template slot-scope="scope">{{ scope.row.mark }}
                            </template>
                        </el-table-column>
                        <template v-for="(field, index) in col">
                            <el-table-column :prop="field.field" :label="field.label" :key="index">
                                <template slot-scope="scope">
                                    <span>{{ scope.row[field.field] }}</span>
                                </template>
                            </el-table-column>
                        </template>
                    </el-table>
                </template>
                <template v-else>
                    <template v-if="obj.data.length!=0">
                        <template v-for="(data,i) in obj.data">
                            <el-row :key="data.id"
                                v-if="boxAddcolumn.length!=0 && boxAddcolumn[num].shortTitle==obj.shortTitle">
                                <template v-for="(item, index) in boxAddcolumn[num].column">
                                    <el-col :span="item.type == 'textarea' || item.type == 'upload' ? 24 : 6"
                                        :key="item.field+index">
                                        <el-form-item :label="item.label" v-if="ifCheck(item)" v-show="!item.hide">
                                            <template v-if="item.type == 'input'">
                                                <el-input v-if="item.formatType" placeholder=""
                                                    :value="!data[item.field+'Show']?judge(data[item.field],item.formatType):data[item.field]"
                                                    @input="data[item.field] = $event"
                                                    :readonly="formReadOnly?true:item.readOnly ? item.readOnly : false">
                                                    <i slot="suffix"
                                                        :class="!data[item.field+'Show']?'el-icon-view':'el-icon-error'"
                                                        @click="IsChildDesenHandle(item.field+'Show',data[item.field+'Show'],num,i)"></i>
                                                </el-input>
                                                <el-input v-else v-model="data[item.field]" placeholder=""
                                                    :readonly="formReadOnly?true:item.readOnly ? item.readOnly : false">
                                                </el-input>
                                            </template>
                                            <template v-else-if="item.type == 'checkbox'">
                                                <el-checkbox v-for="(v, index) in item.option" :key="index"
                                                    :label="v.label"
                                                    :value="!data[v.field] || data[v.field] == '' ? false : data[v.field] == 'on' ? true : false"
                                                    :disabled="formReadOnly?true:item.readOnly ? item.readOnly : false"
                                                    style="height: 33px;"></el-checkbox>
                                            </template>
                                            <template v-else-if="item.type == 'textarea'">
                                                <el-input type="textarea" rows="5" v-model="data[item.field]"
                                                    placeholder=""
                                                    :readonly="formReadOnly?true:item.readOnly ? item.readOnly : false">
                                                </el-input>
                                            </template>
                                            <template v-else-if="item.type == 'select'">
                                                <el-select v-model="data[item.field]" placeholder=""
                                                    :disabled="formReadOnly?true:item.readOnly ? item.readOnly : false"
                                                    class="w100">
                                                    <el-option v-for="item in item.option" :key="item.value"
                                                        :label="item.label" :value="item.value">
                                                    </el-option>
                                                </el-select>
                                            </template>
                                            <template v-else-if="item.type == 'upload'">
                                                <template v-for="(item,index) in data[item.field]">
                                                    <el-image style="width: 100px; height: 100px" :key="index"
                                                        :src="item.indexOf('http') != -1 ? item : $apiUrl + item"
                                                        :preview-src-list="[item.indexOf('http') != -1 ? item : $apiUrl + item]">
                                                    </el-image>
                                                </template>
                                            </template>
                                            <template v-else-if="item.type == 'richText'">
                                                <el-button type="primary" size="small" @click="open(data[item.field])">
                                                    查看内容</el-button>
                                            </template>
                                            <template v-else-if="item.type == 'info'">
                                                <el-button type="primary" size="small"
                                                    @click="openInfo(data[item.field])">查看详情</el-button>
                                            </template>
                                            <template v-else-if="item.type == 'date'">
                                                <el-date-picker v-model="data[item.field]" type="date" placeholder=""
                                                    class="w100"
                                                    :disabled="formReadOnly?true:item.readOnly ? item.readOnly : false">
                                                </el-date-picker>
                                            </template>
                                            <template v-else-if="item.type == 'number'">
                                                <el-input-number v-model="data[item.field]" :min="1" :max="item.max"
                                                    :disabled="formReadOnly?true:item.readOnly ? item.readOnly : false">
                                                </el-input-number>
                                            </template>
                                        </el-form-item>
                                    </el-col>
                                </template>
                            </el-row>
                        </template>

                    </template>
                    <template v-else>
                        <el-empty :image-size="100" :key="num" :description="`无${obj.shortTitle}数据`"></el-empty>
                    </template>
                </template>
            </template>
        </el-form>
        <div class="flow_Record d2-mt-5 d2-mb-10" v-if="flowRecord.length!=0">
            <el-steps direction="vertical" :active="active" active-color="#4196ff">
                <el-step v-for="(item, i) in flowRecord" :key="i" icon="el-icon-success">
                    <div slot="description" class="step-box" @click="item.Receiver?look(item):''">
                        <img
                            :src="item.AvatarUrl && item.AvatarUrl != '' ? $apiUrl + item.AvatarUrl : require('@/assets/img/avatarUrl.png') " />
                        <div class="step-infobox">
                            <div class="user">
                                {{ item.ProcessBy ? `${item.ProcessByName}(${item.ProcessBy})` : item.Actor}}
                            </div>
                            <div class="time">{{ item.ProcessTime }}</div>
                            <div class="action">{{ item.Actor }}</div>
                            <div class="time">
                                {{item.Action == ""? item.Actor == "开始"? "待提交": "待审批" : item.Action}}
                                {{ item.Receiver ? "(点击查看详情)" : "" }}
                            </div>
                            <div>{{ item.Content }}</div>
                        </div>
                    </div>
                </el-step>
            </el-steps>
        </div>
        <div slot="footer" class="dialog-footer" v-if="name=='我的申请'">
            <el-button type="primary" :disabled='workFlowOver || !getFlowOk' @click="addToRush">加 催
            </el-button>
            <el-button type="primary" :disabled='workFlowOver || !getFlowOk' @click="abolish">撤销申请
            </el-button>
        </div>
        <template v-if="workFlowButton">
            <!-- 为了样式 -->
            <div slot="footer" class="dialog-footer" v-if="name=='待处理' || name=='我的任务'">
                <el-button v-for='(item,index) in workFlowButton' :key="index"
                    :type="item.name=='不同意'?'danger':'primary'" :disabled='workFlowOver || !getFlowOk'
                    @click="agreeHandle(item)" v-show="setting.isActive ? (item.name == '提交' ? false : true) : true">
                    {{item.name}}</el-button>
            </div>
        </template>
        <!-- 查看内容 -->
        <el-dialog title="查看内容" :visible.sync="dialogConVisible" width="50%" :before-close="handleClose"
            :append-to-body="true">
            <div class="web_view_con" v-html="htmlcon"></div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="dialogConVisible = false">取 消</el-button>
            </span>
        </el-dialog>
        <!-- 小组长信息 -->
        <el-dialog title="小组长信息" :visible.sync="dialogGroupVisible" width="45%" :before-close="handleGroupClose"
            :append-to-body="true">
            <el-table :data="groupList" style="width: 100%">
                <el-table-column prop="Name" label="姓名">
                </el-table-column>
                <el-table-column prop="Mobile" label="电话">
                </el-table-column>
                <el-table-column prop="Email" label="邮箱">
                </el-table-column>
            </el-table>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogGroupVisible = false" plain size="small">取 消</el-button>
            </span>
        </el-dialog>
        <!-- 待审批 -->
        <el-dialog :visible.sync="dialogReceiverVisible" width="40%" :before-close="handleReceiverClose"
            :append-to-body="true">
            <div v-for="(item,index) in ReceiverList" :key="index">
                <div class="receiver_sec">
                    <d2-icon class="receiver_sec_icon" name='users' />
                    <div class="receiver_sec_info">
                        <p>姓名：{{item.Name}}</p>
                        <p>邮箱：{{item.Email}}</p>
                    </div>
                </div>
                <div class="border_all"></div>
            </div>
        </el-dialog>
        <!-- 不同意 -->
        <el-dialog title='审批' :visible.sync="dialogReasonVisible" width="30%" :before-close="handleReasonClose"
            :append-to-body="true" center>
            <el-form class="d2-mr-10 d2-mt-5" ref="reasonform" :model="reasonform" label-width="80px" size="small">
                <el-form-item prop="notActionEventText" label="后续操作"
                    :rules="[{ required: true, message: '不能为空', trigger: 'blur'}]">
                    <el-select v-model="reasonform.notActionEventText" placeholder="请选择后续操作" class="w100">
                        <el-option v-for="val in notActionSelectText" :label="val.name" :value="val.event"
                            :key="val.event">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item prop="notActionText" label="原因"
                    :rules="[{ required: true, message: '不能为空', trigger: ['blur', 'change'] }]">
                    <el-input type="textarea" rows="5" v-model="reasonform.notActionText"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="handleReasonClose">取 消</el-button>
                <el-button type="primary" :loading="loading" @click="saveReason">保存</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
    import * as indexService from "@/api/sys/index";
    import form from "@/libs/form";
    import _ from "lodash";
    import moment from "moment";
    export default {
        name: "TaskCommon",
        props: {
            listDetialData: Object,
            name: String,
            value: Boolean,
        },
        data() {
            return {
                loading: false,
                dialogConVisible: false,
                formLabelWidth: "150px",
                title: "",
                htmlcon: '',
                permission: false,
                formReadOnly: false, //只读
                shortTitle: '', //标题
                form: {},
                formDetial:{},
                childList: [],
                childrenData: [],
                jsform: {},
                flowRecord: [],
                active: 0,
                column: [],
                boxAddcolumn: [],
                col: [],
                formcol: [],
                slot: '',
                outData: [],
                treeData: [],

                // 待审核
                dialogReceiverVisible: false,
                ReceiverList: [],

                options: [],
                groupList: [],
                dialogGroupVisible: false, //小组长弹窗

                workFlowOver: false, // 加崔撤销按钮是否禁用
                getFlowOk: false,

                //不同意
                dialogReasonVisible: false,
                workFlowButton: null,
                notActionSelectText: [], // 不同意列表
                reasonform: {
                    notActionEventText: '',
                    notActionText: ''
                },
                setting: {},
                next_workFlowMap: ['同意', '提交', '回复'],
            };
        },
        created() {

        },
        computed: {
            eval() {
                return (str) => {
                    try {
                        var a = eval(str);
                        return a;
                    } catch (e) {
                        return false;
                    }
                };
            },
        },
        methods: {
            async getFieldName(value){
                let param = {
                    url: value
                };
                let name = "";
                let res = await indexService.GetFileName(param);
                if(res.success){
                    name = res.data.substr(res.data.lastIndexOf('/') + 1);
                }
                return name;
            },
            // 获取 shortTitle
            GetRootConfigValue(shortTitle) {
                this.jsform = form.OPTION_JF_FORM;
                this.shortTitle = shortTitle;
                let parmas = {
                    dataId: this.listDetialData.ID,
                    shortTitle: shortTitle,
                    templateId: this.listDetialData._TEMPLATE_ID,
                };
                this.loading = true;
                indexService.GetRootConfigValue(parmas).then((data) => {
                    this.title = data.data.value;
                    Object.keys(this.jsform).map((key, index) => {
                        if (key == this.title) {
                            this.setting = this.jsform[key]
                            this.jsform[key].config.forEach((v) => {
                                if (v.mainForm) {
                                    this.column = _.cloneDeep(v.column);
                                    this.getDetial(shortTitle);
                                } else if (v.boxAdd) {
                                    this.boxAddcolumn.push({
                                        shortTitle: v.shortTitle,
                                        column: v.column
                                    })
                                } else if (v.ismx) {
                                    this.col = v.detail ? v.detail : [];
                                    this.formcol = v.column ? v.column : [];
                                    this.slot = v.config && v.config.slot ? v.config.slot : '';
                                }
                            });
                        }
                    });
                    this.loading = false;
                }).catch((err) => {
                    this.close();
                    this.loading = false;
                });
            },
            // 获取详情
            getDetial(shortTitle, flag) {
                if (flag) this.$emit('message')
                if (this.listDetialData.ID) {
                    this.formReadOnly = true;
                    if (shortTitle == '活动信息表') {
                        let parmas = {
                            activityId: this.listDetialData.ID,
                        };
                        this.loading = true;
                        // 详情
                        indexService.GetActivityInfo(parmas).then((data) => {
                            Object.keys(data.data.mainData).map( v => {
                                if (v == 'Files' || v == 'PopImage' || v == 'CoverImg' || v ==
                                    'FaceImage') {
                                    let img = data.data.mainData[v].split(',')
                                    data.data.mainData[v] = img
                                }

                            })
                            this.form = data.data.mainData;
                            this.childrenData = data.data.childrenData;
                            this.GetWorkflowRecord(flag);
                            this.GetInvitee();
                            this.loading = false;
                        });
                    } else if (shortTitle == '会员信息修改审批单' || shortTitle == '入会申请审批表') {
                        let action = this.setting.getOldDataAction.action;
                        let parmas = {
                            dataId: this.listDetialData.ID,
                            detailed: true,
                            shortTitle: shortTitle
                        }
                        this.loading = true;
                        indexService.getActiveDataList(action, parmas).then((data) => {
                            Object.keys(data.data.mainData).map( v => {
                                if (v == 'IdCardImg1' || v == 'IdCardImg2' || v == 'avatarUrl') {
                                    let img = data.data.mainData[v].split(',')
                                    data.data.mainData[v] = img.map((b) => {
                                        return b.indexOf('http') != -1 ? b : this.$apiUrl + b
                                    });
                                }
                            })
                            this.form = data.data.mainData;
                            this.GetWorkflowRecord(flag);
                            data.data.childrenData.forEach(v => {
                                v.data = v.data.map(b => {
                                    Object.keys(b).map(n => {
                                        if (n == 'BirthIdentity') {
                                            let img = b[n].split(',')
                                            b[n] = img.map((i) => {
                                                return i.indexOf('http') != -1 ?
                                                    i : this.$apiUrl + i
                                            });
                                        }
                                    })
                                    return b
                                })
                                this.childrenData.push(v)
                            });
                            this.GetCityData1();
                            this.loading = false;
                        });
                    } else {
                        let parmas = {
                            dataId: this.listDetialData.ID,
                            detailed: true,
                            shortTitle: shortTitle,
                        };
                        this.loading = true;
                        // 详情
                        indexService.getActiveDetialData(parmas).then((data) => {
                            Object.keys(data.data.mainData).map( async v => {
                                if (v == 'Annex') {
                                    let img = data.data.mainData[v].split(',');
                                    let file = [];
                                    if(img[0] != ''){
                                        for(const i of img){
                                            if(i.includes('http')){
                                                file.push({
                                                    name: await this.getFieldName(i),
                                                    url: i
                                                })
                                            }else{
                                                file.push({
                                                    name: i,
                                                    url: i
                                                })
                                            }
                                        }
                                    }
                                    data.data.mainData[v] = file;;
                                }else if (v == 'Files' || v == 'PopImage' || v == 'CoverImg' || v ==
                                    'FaceImage' || v == 'FJ') {
                                    let img = data.data.mainData[v].split(',')
                                    data.data.mainData[v] = img;
                                    // .map((b) => {
                                    //     return b.indexOf('http') != -1 ? b : this.$apiUrl + b
                                    // });
                                }

                            })
                            this.form = data.data.mainData;
                            this.childrenData = data.data.childrenData;
                            this.GetWorkflowRecord(flag);
                            this.loading = false;
                        });
                    }
                    console.log(this.form, this.title, this.column)
                    console.log("childrenData",this.childrenData);
                    this.column.map(n => {
                        if (n.type == 'checkbox' && !n.option) {
                            let option = this.form[n.field].split("$|$")
                            var obj = {};
                            var array = [];
                            option.map((v, i) => {
                                if (i == 0 && v) {
                                    v = v.split(",");
                                    v.map((item) => {
                                        obj["checkBox_" + item + "_" + n
                                            .field] = 'on';
                                        this.$set(this.form, "checkBox_" +
                                            item + "_" + n.field, 'on')
                                        array.push({
                                            label: item,
                                            field: "checkBox_" + item +
                                                "_" + n.field
                                        })
                                    })
                                } else if (v) {
                                    v = v.split(",");
                                    v.map((item) => {
                                        obj["checkBox_" + item + "_" + n
                                            .field] = 'off';
                                        this.$set(this.form, "checkBox_" +
                                            item + "_" + n.field, 'off')
                                        array.push({
                                            label: item,
                                            field: "checkBox_" + item +
                                                "_" + n.field
                                        })
                                    })
                                }
                            })
                            n.option = array
                        } else if (n.type == 'checkbox' && n.option) {
                            // console.log(n.option)
                        }
                    })
                    setTimeout(() => {
                        this.childrenData.forEach(v => {
                            let data = v.data.map(v => {
                                return {
                                    ...v,
                                    children: []
                                }
                            })
                            if (!this.slot) {
                                this.formatData(data);
                                this.formDetial=v.mainData
                            } else {
                                if (this.slot == 'jf') this.jfDataFormat(data);;
                            }
                        })
                    }, 1000);

                } else {
                    this.formReadOnly = false;
                    this.title = "";
                }
            },
            getReplyPermission(quitReadonly, spEd) {
                if (this.name == "我的任务" || this.name == "待处理") {
                    let query = {
                        dataId: this.listDetialData.ID,
                        templateId: this.form._TEMPLATE_ID,
                    };
                    this.workFlowButton = [];
                    // 权限
                    indexService.getReplyPermission(query).then((data) => {
                        if (data.data.permission) {
                            this.permission = data.data.permission;
                            if (quitReadonly) {
                                this.formReadOnly = false;
                            }
                            var {
                                subdatas
                            } = data.data;
                            var notArray = [];
                            var button = [];
                            for (var i = 0; i < subdatas.length; i++) {
                                if (this.next_workFlowMap.indexOf(subdatas[i].name) == -1) {
                                    notArray.push(subdatas[i]);
                                } else {
                                    button[0] = subdatas[i];
                                }
                            }
                            this.notActionSelectText = notArray;
                            if (notArray.length != 0) {
                                button[1] = {
                                    name: "不同意",
                                };
                            }
                            this.workFlowButton = button;
                        } else {
                            this.formReadOnly = true;
                            console.log(!spEd)
                            if (!spEd && !this.workFlowOver) {
                                this.$message.warning('信息审批中，请等待流程完毕')
                            }
                        }
                    });
                }
            },
            // 是否选中
            ifCheck(col) {
                var _this = this;
                if (col.if) {
                    var a = eval(col.if);
                    if (!a) {

                    }
                    return a;
                }
                return true;
            },
            // 受邀人员
            GetInvitee() {
                let query = {
                    activityId: this.listDetialData.ID,
                };
                indexService.GetInvitee(query).then((data) => {

                });
            },
            // 流程
            GetWorkflowRecord(spEd) {
                let parmas = {
                    dataId: this.listDetialData.ID,
                    templateId: this.form._TEMPLATE_ID,
                };
                this.flowRecord = []
                indexService.GetWorkflowRecord(parmas).then((data) => {
                    this.flowRecord = data.data;
                    this.active = data.data.length;
                    this.loading = false;
                    var flag = false;

                    for (var i = 0; i < data.data.length; i++) {
                        if (data.data[i].Action == "") {
                            if (data.data[i].Actor == "开始" && data.data[i].ProcessTime == "") {
                                flag = true;
                            }
                            break;
                        } else {
                            this.waitWorkFlowPermission = true;
                            if (i == data.data.length - 1) {
                                if (data.data[i].Action == "已撤销") {}
                                if (data.data[i].Action == "主动撤销") {}
                                this.workFlowOver = true;
                                if (this.name != "我的已处理" && this.name != "已处理") {
                                    this.$message.warning("流程已结束")
                                }
                            }
                        }
                    }
                    this.getReplyPermission(flag, spEd);
                    // otherFunction(flag);
                    this.getFlowOk = true;

                });
            },
            // 提交
            submitHandle() {
                this.$refs["form"].validate((valid) => {
                    if (valid) {
                        this.loading = true;
                        let form = {
                            ID: this.listDetialData.ID,
                            Reply: this.form.replytext,
                            IsOpen: this.form.IsOpen,
                        };
                        indexService
                            .addReplayData({
                                ...form,
                            })
                            .then((data) => {
                                this.$message.success("回复成功！");
                                this.loading = false;
                                this.dialogVisible = false;
                                window.location.reload();
                            })
                            .catch((e) => {
                                this.dialogVisible = false;
                            });
                    } else {
                        return false;
                    }
                });
            },
            //城市信息
            GetCityData1() {
                indexService.GetCityData1().then((data) => {
                    let value = _.findIndex(data, ["text", "已选"]);
                    if (value == -1 && this.form.City) {
                        data.data.push({
                            text: "已选",
                            id: "已选",
                            children: [{
                                text: this.form.City,
                                id: this.form.City,
                            }, ],
                        });
                    }
                    this.options = data.data;
                });
            },
            //城市信息
            GetGroupByUser() {
                console.log(this.formDetial)
                indexService.GetGroupByUser().then((data) => { 
                    this.options = data.data;
                });
            },
            //   查看内容
            open(con) {
                this.dialogConVisible = true;
                this.htmlcon = con;
            },
            //   查看详情
            openInfo(code) {
                let query = {
                    MemberCode: code
                }
                this.dialogGroupVisible = true
                indexService.GetGroupManager(query).then((data) => {
                    this.groupList = data.data
                });
            },
            handleGroupClose() {
                this.dialogGroupVisible = false;
                this.groupList = []
            },
            handleClose() {
                this.dialogConVisible = false;
                this.htmlcon = ''
            },
            handleReceiverClose() {
                this.dialogReceiverVisible = false;
                this.ReceiverList = []
            },
            look(item) {
                this.dialogReceiverVisible = true;
                this.ReceiverList = item.Receiver
            },
            // 加催
            addToRush() {
                var param = {
                    shortTitle: this.listDetialData.Type,
                    dataId: this.form.ID,
                };
                indexService.AddUrgentMessage(param).then((data) => {
                    this.$message.success('加催成功，请耐心等待！');
                    this.$emit('close')
                    this.close();
                    // this.getAddToRushStatus();
                }).catch((e) => {
                    // this.$message.error(e)
                });
            },
            //   获取加催状态
            getAddToRushStatus() {
                var param = {
                    shortTitle: this.listDetialData.Type,
                    dataId: this.form.ID
                };
                indexService.GetUrgentStatus(param).then((data) => {
                    var {
                        Status
                    } = data.data;
                    if (Status == 1) {
                        // this.workFlowStatus = "加催中";
                    }
                });
            },
            // 取消
            abolish() {
                this.$confirm('是否确定撤销申请?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.loadings = true;
                    var param = {
                        configId: this.form._CONFIG_ID
                    };
                    indexService.DischargePetition(param).then(() => {
                        this.$message.success("撤销成功！");
                        this.$emit('close')
                        this.close();
                    }).catch((e) => {

                    });
                }).catch(() => {

                });
            },
            //同意
            agreeHandle(item) {
                console.log(item)
                if (item.name == '不同意') {
                    this.dialogReasonVisible = true
                } else if (item.event || item.next) {
                    
                    const workRunOk = () => {
                        // 提交
                        // this.updateSubmitHandle(); //暂时注释
                        this.workFlowRun(item);
                    };
                    if (item.name == "提交" || item.next) {
                        workRunOk();
                        return;
                    }
                    if (item.name == "回复") {
                        this.replyActionTextShow = true;
                    } else if (this.setting.okNeedIdea) {
                        this.okActionTextShow = true;
                    } else {
                        this.$alert('同意并进行到下一步', '是否同意', {
                            confirmButtonText: '确定',
                            callback: action => {
                                workRunOk();
                            }
                        });
                    }

                } else {

                }
            },
            /**
             * 修改提交
             * checkbox 并且async  请求数据并填充， 已有数据选中
             * boxAdd 显示删除添加按钮 
             * shortTitle: this.shortTitle,
             * dataId: this.listDetialData.ID,
             * 
             */
            updateSubmitHandle() {
                this.$refs["form"].validate((valid) => {
                    if (valid) {


                        // this.loading = true;
                        let form = this.getFormAllData();
                        console.log(form)
                        // indexService.addQuestionData({
                        //     ...form,
                        // }).then((data) => {
                        //     this.$message.success("修改成功！");
                        // }).catch((e) => {
                        //     this.loading = false;
                        // });
                    } else {
                        return false;
                    }
                });
            },
            // 解析获得所有表单数据
            getFormAllData() {
                var formData = this.getAllFormRenderData();
                // var formData = this.formData;
                var {
                    config
                } = this.setting;

                var form = {
                    dataId: this.listDetialData.ID,
                    shortTitle: this.shortTitle,
                };
                var mainData = {};
                var childrenData = [];

                for (var i = 0; i < config.length; i++) {
                    var set = config[i];
                    if (formData[set.name]) {
                        if (set.mainForm) {
                            for (var key in formData[set.name]) {
                                if (formData[set.name][key]) {
                                    // 处理checkbox

                                    var checkBoxValueObj = {};
                                    var notCheckBoxValueObj = {};
                                    for (var checkBox in formData[set.name][key]) {
                                        try {
                                            var split = checkBox.split("_");
                                            if (split[0] == "checkBox" && split[2]) {
                                                !checkBoxValueObj[split[2]] ?
                                                    (checkBoxValueObj[split[2]] = []) :
                                                    null;
                                                !notCheckBoxValueObj[split[2]] ?
                                                    (notCheckBoxValueObj[split[2]] = []) :
                                                    null;
                                                if (formData[set.name][key][checkBox] == "on") {
                                                    checkBoxValueObj[split[2]].push(split[1]);
                                                } else {
                                                    notCheckBoxValueObj[split[2]].push(split[1]);
                                                }
                                            }
                                        } catch (e) {}
                                    }
                                    for (var join in checkBoxValueObj) {
                                        checkBoxValueObj[join] = checkBoxValueObj[join].join(",");
                                        if (notCheckBoxValueObj[join]) {
                                            var notStr = notCheckBoxValueObj[join].join(",");
                                            checkBoxValueObj[
                                                join
                                            ] = `${checkBoxValueObj[join]}$|$${notStr}`;
                                        }
                                        formData[set.name][key][join] = checkBoxValueObj[join];
                                    }

                                    mainData = formData[set.name][key];
                                    form.shortTitle = set.shortTitle;
                                    break;
                                }
                            }
                        } else {
                            var data = [];
                            for (var key in formData[set.name]) {
                                data.push(formData[set.name][key]);
                            }
                            var thatJson = {
                                shortTitle: set.shortTitle,
                                data: data,
                            };
                            childrenData.push(thatJson);
                        }
                    }
                }

                form.mainData = mainData;
                form.childrenData = childrenData;
                return form;
            },
            handleReasonClose() {
                this.dialogReasonVisible = false;
                this.$refs.reasonform.resetFields();
            },
            workFlowRun(item) {
                let params = {
                    dataId: this.form.ID,
                    processOpinion: '',
                    processResult: item.event,
                    templateId: this.form._TEMPLATE_ID
                }
                indexService.ProcessWorkflowAction(params).then(data => {
                    this.getDetial(this.listDetialData.Type, true);
                }).catch(e => {});
            },
            //   同意
            saveReason() {
                this.$refs["reasonform"].validate(valid => {
                    if (valid) {
                        this.loading = true;
                        let f = this.reasonform;
                        let processOpinion = _.filter(this.notActionSelectText, function (o) {
                            return o.event == f.notActionEventText;
                        });
                        let params = {
                            dataId: this.form.ID,
                            processOpinion: processOpinion[0].name,
                            processResult: f.notActionEventText,
                            templateId: this.form._TEMPLATE_ID
                        }
                        indexService.ProcessWorkflowAction(params).then(data => {
                            this.loading = false;
                            this.handleReasonClose();
                            this.getDetial(this.listDetialData.Type, true);
                        }).catch(e => {
                            this.loading = false;
                        });
                    } else {
                        return false;
                    }
                });
            },
            // 脱敏规则
            judge(val, type) {
                if (type == 'idCard') {
                    if (!val) return ''
                    let reg = /^(.{3}).*(.{2})$/
                    return val.replace(reg, '$1*************$2')
                } else {
                    if (!val) return ''
                    let reg = /^(.{3}).*(.{4})$/
                    return val.replace(reg, '$1****$2')
                }
            },
            // 脱敏主表切换
            IsDesenHandle(field, value) {
                this.form[field] = !this.form[field];
                this.$forceUpdate();
            },
            // 脱敏分表切换
            IsChildDesenHandle(field, value, num, index) {
                this.childrenData[num].data[index][field] = !this.childrenData[num].data[index][field];
                this.$forceUpdate();
            },
            close() {
                this.$refs.form.resetFields();
                this.form = {};
                this.column = [];
                this.jsform = {};
                this.formDetial={};
                this.childrenData = [];
                this.flowRecord = [];
                this.title = "";
                this.workFlowOver = false;
                this.getFlowOk = false;
                this.workFlowButton = [];
                this.slot = '';
                this.col = [];
                this.formcol = [];
                this.$forceUpdate();
            },
            // 
            formatData(childList) {
                var data= JSON.parse(JSON.stringify(childList));
                var col = this.col;
                for(var i=0;i<childList.length;i++){
                    var  item = childList[i];
                    var item1 = data[i];
                    for (var o = 0; o < col.length; o++) {
                        item1[col[o].field] = this.formatValue(
                            item[col[o].field],
                            col[o].type,
                            col[o].momentFormat
                        );
                    }
                }
                this.outData = data;
            },
            formatValue(v, type, momentFormat) {
                var rv = v;
                switch (v) {
                    case true:
                        rv = "是";
                        break;
                    case false:
                        rv = "否";
                        break;
                    case -1:
                        rv = "无限制";
                        break;
                }
                if (v > 100000) {
                    typeof v == "number" ? (rv = "无限制") : null;
                }
                switch (type) {
                    case "day":
                        rv = new moment(v).format("ddd");
                        break;
                    case "tel":
                        rv = v;
                        break;
                }
                if (momentFormat) {
                    try {
                        var time = new moment(rv);
                        rv = time.format(momentFormat);
                    } catch (e) {
                        return rv;
                    }
                }
                if(rv=="Invalid date"){
                    rv= v;
                }
                return rv;
            },
            // 合并单元格
            arraySpanMethod({
                row,
                column,
                rowIndex,
                columnIndex
            }) {
                if (row.children.length != 0) {
                    if (columnIndex === 0) {
                        return [1, 4];
                    }
                }
            },
            jfDataFormat(childList) {
                var fId = 90000;
                var lId = 190000;
                var mockId = 290000;
                var SubstationArray = [];
                var GroupName = [];
                var treeMock = [];
                var treeData = {};

                var data = _.cloneDeep(childList);
                const treeBuild = (item) => {
                    if (item.Substation) {
                        // 查询分站
                        var f = SubstationArray.find((fi) => fi.mark == item.Substation);

                        if (f) {
                            // 有分站序列,检查小组
                            var L = GroupName.find((Li) => Li.mark == item.GroupName);

                            if (L) {
                                // 有小组序列
                            } else {
                                // 无小组序列，绑定小组序列
                                GroupName.push({
                                    mark: item.GroupName,
                                    id: lId,
                                    lId: lId,
                                    parentId: f.id,
                                    isGroup: true,
                                });
                                lId++;
                                treeBuild(item);
                            }
                        } else {
                            // 无，新增
                            SubstationArray.push({
                                mark: item.Substation,
                                id: fId,
                                parentId: null,
                                isSubstation: true,
                            });
                            fId++;
                            treeBuild(item);
                        }
                    }
                };

                var newData = data.map((item) => {
                    treeBuild(item);
                    // 这里处理正常数据
                    var findId = GroupName.find(
                        (findItem) => findItem.mark == item.GroupName
                    );
                    if (findId) {
                        treeData[findId.lId] ? null : (treeData[findId.lId] = []);
                        findId.children ? null : (findId.children = []);

                        item.id = item.ID;
                        item.parentId = findId.lId;
                        findId.children.push(item);

                        treeData[findId.lId].push(item);
                        treeMock.push(item);
                    }
                    return item;

                    // item.Substation ? SubstationArray
                });

                // 处理生成合计,小组
                GroupName = GroupName.map((GroupItem) => {
                    let {
                        children,
                        mark
                    } = GroupItem;
                    let sumObj = this.getSumObject(children);
                    let addStr = `人数：${children.length}`;
                    for (var key in sumObj) {
                        addStr += `，${key}：${sumObj[key]}`;
                    }
                    GroupItem.mark =
                        mark + "\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0" + addStr;

                    sumObj.lengths = children.length;
                    GroupItem.addJson = sumObj;
                    return GroupItem;
                });

                // 处理生成合计,分站
                SubstationArray = SubstationArray.map((sItem) => {
                    var {
                        mark
                    } = sItem;
                    let filter = GroupName.filter((item) => item.parentId == sItem.id);
                    if (filter != "") {
                        var addStr = `小组数量：${filter.length}`;
                        var addJson = {};

                        // 计算分组数据
                        for (var item of filter) {
                            let {
                                addJson: obj
                            } = item;

                            for (var key in obj) {
                                addJson[key] = this.add(
                                    addJson.hasOwnProperty(key) ? addJson[key] : 0,
                                    obj[key]
                                );
                            }
                        }

                        addStr += `，分站人数：${addJson.lengths}`;

                        for (var key in addJson) {
                            if (key != "lengths") {
                                addStr += `，${key}：${addJson[key]}`;
                            }
                        }

                        sItem.mark =
                            mark + "\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0" + addStr;
                        sItem.children = filter
                        return sItem;
                    }
                });

                // this.outData = [...GroupName, ...SubstationArray, ...treeMock];
                this.outData = SubstationArray
                this.treeData = treeData;
            },
            getSumObject(children) {
                let {
                    col
                } = this;
                col = col.filter((colItem) => colItem.sum == true);
                var json = {};
                col.map((item) => {
                    let {
                        label,
                        field
                    } = item;
                    let num = 0;
                    for (var i = 0; i < children.length; i++) {
                        if (children[i].hasOwnProperty(field)) {
                            try {
                                num = this.add(num, Number(children[i][field]));
                            } catch (e) {
                                num = "计算错误，非数字";
                                break;
                            }
                        }
                    }
                    json[label] = num;
                });
                return json;
            },
            add(arg1, arg2) {
                var r1, r2, m;
                try {
                    r1 = arg1.toString().split(".")[1].length
                } catch (e) {
                    r1 = 0
                }
                try {
                    r2 = arg2.toString().split(".")[1].length
                } catch (e) {
                    r2 = 0
                }
                m = Math.pow(10, Math.max(r1, r2))
                return (arg1 * m + arg2 * m) / m
            }
        },
    };
</script>
<style lang="scss" scoped>
    .dialog-footer {
        position: sticky;
        bottom: 0;
        text-align: center;
        background: #fff;
        padding: 10px 0;
        border-top: 1px solid #eee;
        z-index: 1;
    }

    .flow_Record {
        padding: 20px;
        margin: 0 20px;
        box-shadow: 0px 0px 15px #bfd3e8;
        border-radius: 10px;
    }

    /deep/ .el-step__description {
        padding-right: 0;
    }

    .step-box {
        display: flex;

        img {
            width: 40px;
            height: 40px;
            border-radius: 50%;
            margin-right: 4px;
        }
    }

    .step-infobox {
        display: flex;
        flex-direction: row;
        width: 100%;
        flex-wrap: wrap;
        align-items: baseline;
        background: #f7faff;
        padding: 8px;
        border-radius: 5px;

        div {
            width: 50%;
            margin-top: 6px;
        }

        .user {
            font-size: 14px;
            color: #000;
        }

        .action {
            color: #999;
            font-size: 14px;
        }

        .time {
            color: #999;
            text-align: right;
            font-size: 12px;
        }
    }
</style>